<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="nationalIdCard" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@nationalIdCardImage">
    National ID Card Image
    <span class="text-danger-text">*</span>
  </label>
  <div
    (click)="fileInput.click()"
    class="border-border placeholder-text-gray hover-border-input-border focus-border-gray-strong flex cursor-pointer items-center gap-4 rounded-[6px] border-[1px] bg-gray-100 px-3 py-2 text-[14px] focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacistNationalIdFid')?.invalid && pharmacyForm().get('pharmacistNationalIdFid')?.touched
    ">
    <button type="button" class="cursor-pointer rounded border px-3" i18n="@@chooseFile">Choose file</button>

    @if (selectedImage()) {
      <span class="text-sm text-gray-600">{{ selectedImage()?.name }}</span>
    } @else {
      <span i18n="@@noFileChosen" class="text-sm text-gray-600">No File Chosen</span>
    }
  </div>

  <input #fileInput id="nationalIdCard" type="file" class="hidden" (change)="onFileSelect($event)" />

  @if (formSubmitted() && !uploadedFid()) {
    <span i18n="@@nationalIdFidRequired" class="text-danger-text text-[12px]">National ID Card Image is required</span>
  }

  @if (validationFormat()) {
    <span class="text-danger-text text-[12px]" i18n="@@formatImageValidation">
      File format must be JPG, JPEG, PNG, or PDF
    </span>
  }
  @if (validationSize()) {
    <span class="text-danger-text text-[12px]" i18n="@@sizeImageValidation">File size must not exceed 5 MB</span>
  }
  @if (errorUploading()) {
    <span class="text-danger-text text-[12px]">{{ errorUploading() }}</span>
  }
</div>
